import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateUserArgs, BackendUser } from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateUser($customerId: ID!, $defaultWorkspaceId: ID) {
    updateUser(customerId: $customerId, defaultWorkspaceId: $defaultWorkspaceId) {
      id
    }
  }
`;

type Variables = BackendMutationUpdateUserArgs;
type Result = Pick<BackendUser, 'id'>;

export const updateUser = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
